export enum EstadosOR {
    ABIERTA = "AB",
    ANULADA = "AN",
    CERRADA = "CC",
    ENCURSO = "EC",
    FACTURADA = "FA",
    FACTURADAPARCIALMENTE = "FP",
    PENDIENTEFACTURAR = "PF",
    PRESUPUESTOABIERTO = "PA",
    PRESUPUESTOACEPTADO = "PC",
    PRESUPUESTOENCURSO = "PE",
    PRESUPUESTONOACEPTADO = "PN",
    PRESUPUESTOCERRADO = "CE",
    REABIERTA = "RA",
    PRESUPUESTO_CiService = "PI"
}
